import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id C1258752-7002-4714-81E3-D90828B5A896
 * name page-layout-header-footer
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/page-layout-header-footer.svg
 * tags
 */
export const PageLayoutHeaderFooterIcon = createSvgIcon(<><path d="M18 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V4C20 2.9 19.11 2 18 2M18 20H6V16H18V20M18 8H6V4H18V8Z" /></>, 'PageLayoutHeaderFooterIcon');
export default PageLayoutHeaderFooterIcon